import type { DeliveryCarrier, DeliveryMode } from './deliveryPricing';
import { deliveryModeToCarrier, isDeliveryCarrier, normalizeDeliveryMode } from './deliveryPricing';

const OFFER_PREFIX = 'Bon de livraison :';
const MODE_TAG_RE = /^\[mode:([a-z_]+)\]\s*/;
const CARRIER_TAG_RE = /^\[carrier:([a-z_]+)\]\s*/;

const DELIVERY_MODES: (DeliveryMode | 'chronopost_home_49' | 'chronopost_home_4p')[] = [
  'colissimo_home',
  'colissimo_pickup',
  'chronopost_relais_13',
  'chronopost_shop2shop',
  'chronopost_relais_europe',
  'chronopost_relais_dom',
  'chronopost_home_13',
  'chronopost_home_10',
  'chronopost_home_18',
  'mondial_relay_pickup',
  'chronopost_home_49',
  'chronopost_home_4p',
];

function isDeliveryMode(value: string): value is DeliveryMode {
  return (DELIVERY_MODES as string[]).includes(value)
    || value === 'chronopost_home_49'
    || value === 'chronopost_home_4p';
}

export function buildDeliveryOfferMessage(carrier: DeliveryCarrier, body?: string): string {
  const defaultBody =
    "J'accepte de restituer l'objet via ce transporteur. Le propriétaire choisira ensuite comment le recevoir (domicile ou point relais) et règlera les frais sur Stripe ; une fois payé, je pourrai expédier le colis.";
  const text = (body?.trim() || defaultBody).trim();
  return `${OFFER_PREFIX} [carrier:${carrier}] ${text}`;
}

export function parseDeliveryOfferCarrier(content: string): DeliveryCarrier | null {
  if (!content.startsWith(OFFER_PREFIX)) return null;
  const rest = content.slice(OFFER_PREFIX.length).trimStart();
  const carrierMatch = rest.match(CARRIER_TAG_RE);
  if (carrierMatch?.[1] && isDeliveryCarrier(carrierMatch[1])) {
    return carrierMatch[1];
  }
  const modeMatch = rest.match(MODE_TAG_RE);
  if (modeMatch?.[1] && isDeliveryMode(modeMatch[1])) {
    return deliveryModeToCarrier(normalizeDeliveryMode(modeMatch[1]) ?? modeMatch[1] as DeliveryMode);
  }
  return null;
}

export function stripDeliveryOfferModeTag(content: string): string {
  if (!content.startsWith(OFFER_PREFIX)) return content;
  const rest = content.slice(OFFER_PREFIX.length).trimStart();
  return rest.replace(CARRIER_TAG_RE, '').replace(MODE_TAG_RE, '').trim();
}

export function isDeliveryOfferMessage(content: string): boolean {
  return content.startsWith(OFFER_PREFIX);
}
